import { REMOVE_NEXT_ROUTE_LOCATION } from '../constants';

export const doRemoveNextRouteLocation =
  () =>
  async ({ dispatch }) =>
    dispatch({ type: REMOVE_NEXT_ROUTE_LOCATION });
